const styles = theme => ({
  form: {
    width: '500px',
  },
  editForm: {
    width: '500px',
    margin: '0 auto',
    paddingTop: '1rem',
    paddingBottom: '2rem',
  },
  box: {
    width: '100%',
    display: 'grid',
    gridTemplate: 'auto / 33% 33% 33%',
    marginBottom: 16,
  },
  marginBottom: {
    marginBottom: 16,
  },
  marginTop: {
    marginTop: '.7rem',
  },
  button: {
    marginTop: '.7rem',
    border: 'none',
    width: 'fit-content',
    alignSelf: 'flex-end',
    '&:hover': {
      border: 'none',
    },
  },
  noPadding: {
    margin: '0!important',
    padding: '0!important',
  },
  fullWidth: {
    width: '100%',
  },
  accordionDetails: {
    overflow: 'auto',
    maxHeight: '35vh',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  conditionSelect: {
    width: '48%',
    margin: '0 auto',
  },
  buttonGroup: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '16px',
  },
  conditionMessage: {
    fontSize: '.8rem',
    color: '6e6e6e',
  },
})

export default styles
